import { genTrackReportInfo, genTrackUrlInfo } from '../components/TrackReport';
import { TrackType } from '../types';
import shared from '../shared';
import { getUrlObj, resolveUrl } from '../helpers/url';
import { loggerDebug, loggerError } from '../helpers/logger';

export function triggerJumpTrackReport(targetInfo: string, toUrl: string) {
    try {
        const reportInfo = genTrackReportInfo({
            targetInfo,
        });
        const toUrlInfo = genUrlInfo(toUrl);

        if (!toUrlInfo) return;

        shared.onReport?.({
            k_track_type: TrackType.jump,
            ...reportInfo,
            ...toUrlInfo,
        });
    } catch (err) {
        loggerError(err);
    }
}

export function genUrlInfo(toUrl: string | undefined | null) {
    if (!toUrl) return null;
    const urlObj = getUrlObj(resolveUrl(toUrl));
    // loggerDebug('urlObj', toUrl, urlObj);
    if (!urlObj) return null;
    const toUrlInfo = genTrackUrlInfo(urlObj);
    return toUrlInfo;
}
